import { ComponentProps, useCallback, useMemo } from 'react';

import { useLocation } from 'react-router-dom';

import { getSearchInputFromSearchParams } from '~/components/Accommodation/Pages/Properties/components/utils';

import useAppNavigation from '~/hooks/useAppNavigation';

import AccommodationPropertiesSearchForm from '../Pages/Properties/components/AccommodationPropertiesSearchForm';

export default function usePagedSearch() {
  const { push } = useAppNavigation();
  const location = useLocation();

  const handleSearchFormSubmission = useCallback<ComponentProps<typeof AccommodationPropertiesSearchForm>['onSubmit']>(
    (formObject) => {
      const urlSearchParamsToPush = new URLSearchParams(formObject);
      push({
        search: urlSearchParamsToPush.toString(),
      });
    },
    [push],
  );

  const urlSearchParams = useMemo<URLSearchParams>(() => new URLSearchParams(location.search), [location.search]);

  const handlePageChange = useCallback(
    (pageIndex: number) => {
      const urlSearchParamsToPush = new URLSearchParams(urlSearchParams);
      if (pageIndex) {
        urlSearchParamsToPush.set('page', String(pageIndex + 1));
      } else {
        urlSearchParamsToPush.delete('page');
      }
      push({
        search: urlSearchParamsToPush.toString(),
      });
    },
    [urlSearchParams, push],
  );
  return useMemo(() => {
    const pageFromSearchParams = urlSearchParams.get('page');
    return {
      searchInput: getSearchInputFromSearchParams(urlSearchParams),
      pageNumber: pageFromSearchParams ? Number(pageFromSearchParams) : 1,
      handlePageChange,
      handleSearchFormSubmission,
    };
  }, [handlePageChange, urlSearchParams, handleSearchFormSubmission]);
}
